"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dehumanizeString;

var _humanize = _interopRequireDefault(require("./humanize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Dehumanises a string; e.g. 'some string', 'Some String', 'Some string' -> 'SomeString'
 * @param input The string to be dehumanised
 */
function dehumanizeString(input) {
  if (input.indexOf(" ") === -1) return input;
  var titlisedWords = input.split(" ").map(function (word) {
    return (0, _humanize["default"])(word);
  });
  return titlisedWords.join("").replace(/ /g, "");
}